export default "__VITE_ASSET__BYFamm8E__"